import { HEALTH_MILESTONES, milestoneProgress } from '@tahi/core';
import { copy } from '../copy';
import { durationText } from '../format';
import { CARD, LABEL } from '../styles';

/** Encouragement after the quit date (spec), never framed as a promise or as medical advice. */
export function Milestones({ minutesSince }: { minutesSince: number }) {
  const { reached, next, minutesToNext } = milestoneProgress(minutesSince);
  const done = new Set(reached.map((m) => m.key));
  return (
    <section aria-label={copy.milestones} className={CARD}>
      <h2 className={LABEL}>{copy.milestones}</h2>
      {next && minutesToNext !== null ? (
        <p className="mt-2 text-fg">
          {copy.nextMilestone(next.label, durationText(minutesToNext))}
        </p>
      ) : null}
      <ul className="mt-3 flex flex-col gap-2">
        {HEALTH_MILESTONES.map((m) => {
          const ok = done.has(m.key);
          return (
            <li
              key={m.key}
              aria-label={`${m.label}, ${ok ? 'reached' : 'not yet'}. ${m.text}`}
              className="flex gap-3"
            >
              <span
                aria-hidden
                className={`mt-1 h-3 w-3 shrink-0 rounded-full ${ok ? 'bg-success' : 'border border-border'}`}
              />
              <span className={ok ? 'text-fg' : 'text-muted'}>
                <span className="font-medium">{m.label}</span>
                {ok ? <span className="ml-2 text-xs text-success">{copy.reached}</span> : null}
                <span className="block text-sm">{m.text}</span>
              </span>
            </li>
          );
        })}
      </ul>
      <p className="mt-3 text-xs text-muted">{copy.milestonesNote}</p>
    </section>
  );
}
